/* -----------------UI--------------- */
import { useAppTheme } from "@hooks/useAppTheme";
import { Box, Button } from "@memorang/ui";
import { useTranslation } from "react-i18next";
type Props = {
	handleAction: (shouldDelete?: boolean) => void;
	primaryActionLabel?: string;
	disablePrimaryButton?: boolean;
	loadingPrimaryButton?: boolean;
};

const DeleteFormActions = (props: Props) => {
	const {
		handleAction,
		primaryActionLabel,
		disablePrimaryButton,
		loadingPrimaryButton,
	} = props;
	const { t } = useTranslation();

	const labelCancel = t("common.cancel");
	const labelContinue = primaryActionLabel ?? t("common.continue");

	const handleCancelPress = () => {
		handleAction(false);
	};

	const theme = useAppTheme();
	return (
		<Box flexDirection="row" gap={16} paddingTop={16} justifyContent="flex-end">
			<Button
				textColor={theme.colors.onSurfaceVariant}
				onPress={handleCancelPress}
			>
				{labelCancel}
			</Button>
			<Button
				mode="contained"
				onPress={() => handleAction(true)}
				disabled={disablePrimaryButton}
				loading={loadingPrimaryButton}
			>
				{labelContinue}
			</Button>
		</Box>
	);
};

export default DeleteFormActions;
